import Image from "../Image/Image";
import viewLegalDocButton from "../../assets/Icons/read_more.png";
import TouchableOpacity from "../TouchableOpacity/TouchableOpacity";
import ButtonToggle from "../ButtonToggle";
import { View } from "react-native";
import { Container, IconWrapper, LegalsButton, LegalText } from "./styled";
import { Props } from "./model";
import useGenericContentStore from "../../store/genericContent.store";

const CreateAccountButton = ({ title, isToggle, toggleTitle, onPress, onPressToggle, disabled }: Props) => {
	const { isNarrow } = useGenericContentStore((state) => ({ isNarrow: state.isNarrow }));

	return (
		<Container>
			{isToggle && (
				<View style={{ opacity: disabled ? 0.5 : 1 }}>
					<ButtonToggle defaultValue={toggleTitle} onPress={onPressToggle} toggleDisabled={disabled} />
				</View>
			)}

			<TouchableOpacity onPress={onPress} style={{ width: isToggle ? "90%" : "100%" }} disabled={disabled}>
				<LegalsButton disabled={disabled}>
					<LegalText isNarrow={isNarrow}>{title}</LegalText>
					<IconWrapper isNarrow={isNarrow} isToggle={isToggle}>
						<Image source={{ uri: viewLegalDocButton }} resizeMode="contain" width="100%" height="100%" />
					</IconWrapper>
				</LegalsButton>
			</TouchableOpacity>
		</Container>
	);
};

export default CreateAccountButton;
